export const SUCCESS_STATUS_RESPONSE_200 = 200;
export const SUCCESS_STATUS_RESPONSE_201 = 201;
export const TOKEN_TO_VALIDATE = 'tokenToValidate';
